import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box,
  Typography,
} from "@mui/material";
import { useCardStore } from "../../@shared/store/useCardsStore";

const availableRewards = [
  "infinity card",
  "finite card",
  "infinity tokens",
  "character card",
  "avatar",
  "card pack",
];

const infinityOptions = [
  50, 100, 150, 200, 250, 300, 400, 500, 1000, 2000, 2500, 5000, 7500, 10000,
];

const AddRewardModal = ({
  open,
  onClose,
  users,
  selectedUserIds,
  onConfirm,
}) => {
  const { infinityCards, characterCards } = useCardStore();

  const isBulk = selectedUserIds.length > 1;
  const selectedUser = !isBulk
    ? users.find((u) => u.id === selectedUserIds[0])
    : null;

  const [rewardType, setRewardType] = useState("");
  const [amount, setAmount] = useState(1);
  const [includeCharCard, setIncludeCharCard] = useState(false);
  const [tokenAmount, setTokenAmount] = useState(100);
  const [description, setDescription] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);

  const handleConfirm = () => {
    const reward = {
      type: rewardType,
      issuedAt: Date.now(),
      claimed: false,
      amount:
        rewardType === "infinity tokens"
          ? tokenAmount
          : rewardType === "card pack"
          ? 1
          : amount,
      reward: {},
      description: description || "",
    };

    if (rewardType === "infinity tokens") {
      reward.reward = { currency: "Infinity Tokens" };
    }

    if (rewardType === "card pack") {
      const shuffled = [...infinityCards].sort(() => 0.5 - Math.random());
      let pack = shuffled.slice(0, 10);

      if (includeCharCard && characterCards.length > 0) {
        const char =
          characterCards[Math.floor(Math.random() * characterCards.length)];
        pack = [...shuffled.slice(0, 9), char];
      }

      reward.reward = { pack: pack };
    }

    if (rewardType === "finite card") {
      // Stub logic — could enhance later with specific selection
      const card = selectedCard
        ? { ...selectedCard, type: "Infinity" }
        : {
            ...[...infinityCards].filter(
              (c) => c.finite === "TRUE" || c.finite === true
            )[
              Math.floor(
                Math.random() *
                  [...infinityCards].filter(
                    (c) => c.finite === "TRUE" || c.finite === true
                  ).length
              )
            ],
            type: "Infinity",
          };
      // Math.floor(Math.random() * infinityCards.length)
      reward.reward = card;
    }

    if (rewardType === "infinity card") {
      // Stub logic — could enhance later with specific selection
      const card = selectedCard
        ? { ...selectedCard, type: "Infinity" }
        : {
            ...[...infinityCards].filter(
              (c) => c.finite === "FALSE" || !card.finite
            )[
              Math.floor(
                Math.random() *
                  [...infinityCards].filter(
                    (c) => c.finite === "FALSE" || !card.finite
                  ).length
              )
            ],
            type: "Infinity",
          };
      // Math.floor(Math.random() * infinityCards.length)
      reward.reward = card;
    }

    if (rewardType === "character card") {
      // Stub logic — could enhance later with specific selection
      const card = selectedCard
        ? { ...selectedCard, type: "character" }
        : {
            ...[...characterCards][
              Math.floor(Math.random() * characterCards.length)
            ],
            type: "character",
          };
      reward.reward = card;
    }
    console.log(reward);
    onConfirm(reward);
    setSelectedCard(null);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isBulk ? "Give Rewards (Bulk)" : "Give Reward"}
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel>Reward Type</InputLabel>
          <Select
            value={rewardType}
            label="Reward Type"
            onChange={(e) => setRewardType(e.target.value)}
          >
            {availableRewards.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* CONDITIONAL FIELDS */}
        {rewardType === "infinity tokens" && (
          <FormControl fullWidth margin="normal">
            <InputLabel>Amount</InputLabel>
            <Select
              value={tokenAmount}
              onChange={(e) => setTokenAmount(Number(e.target.value))}
            >
              {infinityOptions.map((val) => (
                <MenuItem key={val} value={val}>
                  {val}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {rewardType === "card pack" && (
          <FormControlLabel
            control={
              <Checkbox
                checked={includeCharCard}
                onChange={(e) => setIncludeCharCard(e.target.checked)}
              />
            }
            label="Include Character Card"
          />
        )}

        {(rewardType === "character card" ||
          rewardType === "finite card" ||
          rewardType === "infinity card") && (
          <FormControl fullWidth margin="normal">
            <InputLabel>Select Character</InputLabel>
            <Select
              value={selectedCard}
              onChange={(e) => setSelectedCard(e.target.value)}
            >
              {rewardType === "character card"
                ? characterCards.map((char) => (
                    <MenuItem key={char} value={char}>
                      <img src={char.imageUrl} alt="" style={{ height: 30 }} />{" "}
                      <Typography>
                        {char.name} - {char.collectionName}
                      </Typography>
                    </MenuItem>
                  ))
                : rewardType === "finite card"
                ? [...infinityCards]
                    .filter((c) => c.finite === "TRUE" || c.finite === true)
                    .map((card) => (
                      <MenuItem key={card} value={card}>
                        <img
                          src={card.imageUrl}
                          alt=""
                          style={{ height: 30 }}
                        />{" "}
                        <Typography>{card.name}</Typography>
                      </MenuItem>
                    ))
                : [...infinityCards]
                    .filter((c) => c.finite === "FALSE" || !c.finite)
                    .map((card) => (
                      <MenuItem key={card} value={card}>
                        <img
                          src={card.imageUrl}
                          alt=""
                          style={{ height: 30 }}
                        />{" "}
                        <Typography>{card.name}</Typography>
                      </MenuItem>
                    ))}
            </Select>
          </FormControl>
        )}

        {(rewardType === "finite card" || rewardType === "infinity card") && (
          <FormControl fullWidth margin="normal">
            <TextField
              label="Amount (1-3)"
              type="number"
              value={amount}
              onChange={(e) =>
                setAmount(Math.max(1, Math.min(3, Number(e.target.value))) || 1)
              }
              inputProps={{ min: 1, max: 3 }}
            />
          </FormControl>
        )}

        <TextField
          label="Description"
          fullWidth
          margin="normal"
          multiline
          minRows={2}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <Box mt={2}>
          <Typography variant="body2">
            {isBulk
              ? `${selectedUserIds.length} users will receive this reward`
              : `Rewarding: ${selectedUser?.username || "Unknown"}`}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!rewardType}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddRewardModal;
